import "./PrivacyPopup.scss";
import { useState, useEffect } from "react";

const PrivacyPopup = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Перевірка, чи є ключ у localStorage
        const privacyAccepted = localStorage.getItem("privacyAccepted");

        // Якщо ще не було прийнято або відхилено політику конфіденційності, відображаємо попап
        if (privacyAccepted === null) {
            setIsVisible(true);
        }
    }, []);

    const acceptPrivacy = () => {
        localStorage.setItem("privacyAccepted", "true");
        setIsVisible(false);
    };

    const declinePrivacy = () => {
        localStorage.setItem("privacyAccepted", "false");
        setIsVisible(false);
    };

    // Якщо політика вже була прийнята або відхилена, попап не відображається
    if (!isVisible) return null;

    return (
        <div className="privacyPopup">
            <h2 className="title">Політика конфіденційності</h2>
            <p className="text">
                Ми використовуємо файли cookie для покращення вашого досвіду на нашому сайті.
                Продовжуючи користуватися сайтом, ви погоджуєтеся з нашою політикою конфіденційності.
            </p>
            <div className="buttonContainer">
                <button className="acceptButton" onClick={acceptPrivacy}>
                    Погоджуюсь
                </button>
                <button className="declineButton" onClick={declinePrivacy}>
                    Відмовляюсь
                </button>
            </div>
        </div>
    );
};

export default PrivacyPopup;
